module.exports = __webpack_public_path__ + "static/img/8.92ba3d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/gameNewPic/8.jpg
// module id = yAxW
// module chunks = 1